import { ReactNode } from 'react';
import { ErrorBoxAction, ErrorBoxActionType } from './errorBoxActionType';

export class ErrorBoxActions {
    public static showBox(errorBoxMessage: ReactNode): ErrorBoxAction {
        return {
            payload: { errorBoxMessage },
            type: ErrorBoxActionType.ADD_BOX_WARNING,
        };
    }
    public static hideBox(): ErrorBoxAction {
        return {
            type: ErrorBoxActionType.REMOVE_BOX_WARNING,
        };
    }
}
